<template>
  <div>
    <circle-loader ref="circleLoader" />
    <div v-if="!submitted">
      <form-wizard
        title="Bienvenido al asistente de configuración"
        subtitle="Por favor siga los pasos para crear su nuevo nodo"
        @on-complete="saveDevice"
        @on-loading="setLoading"
        @on-validate="handleValidation"
        shape="square"
        color="#5cb85c"
        stepSize="xs"
        :nextButtonText="nextLabel"
        backButtonText="Anterior"
        finishButtonText="Crear nodo"
      >
        <!-- LOADER (OCULTO POR DEFECTO)-->
        <div class="loader" v-if="loadingWizard"></div>

        <!-- PESTAÑA 1: IDENTIFICACIÓN-->
        <tab-content
          title="Datos de identificación"
          :before-change="validateIdentity"
        >
          <div class="contab" style="min-height: 200px; padding: auto">
            <p style="margin-top: 50px">
              Información para identificar su nuevo nodo
            </p>
            <b-row>
              <b-col>
                <b-card title="" id="alias">
                  <div class="cardContent">
                    <label for="aliasinput">Alias del dispositivo</label>
                    <b-form-input
                      v-model="device.alias"
                      v-bind:required="true"
                      style="width: 80%; margin: auto"
                      name="aliasinput"
                    />
                  </div>
                </b-card>
              </b-col>
              <b-col>
                <b-card title="" id="uuid">
                  <div class="cardContent">
                    <label for="uuidinput">UUID del dispositivo</label>
                    <b-form-input
                      v-model="device.uuid"
                      v-bind:required="true"
                      style="width: 80%; margin: auto"
                      name="uuidsinput"
                    />
                  </div>
                </b-card>
              </b-col>
            </b-row>
            <p class="errorValidacion" v-if="identCamposVacios">
              Debe rellenar ambos campos
            </p>
            <p class="errorValidacion" v-if="identAliasDuplicado">
              No puede introducir un alias duplicado
            </p>
          </div>
        </tab-content>

        <!-- PESTAÑA 2: UBICACIÓN-->
        <tab-content
          title="Datos de ubicación"
          :before-change="validateLocation"
        >
          <div class="contab">
            <b-row style="width: 100%; margin: auto">
              <b-col>
                <!--CONTENEDOR SELECCIÓN-->
                <div id="select" v-if="selectAsociar" style="min-height: 400px">
                  <p>¿Desea asociar una ubicación existente?</p>
                  <b-row>
                    <b-col style="margin-right: 90px">
                      <b-card
                        @click="
                          (selectAsociar = false),
                            (asociarUbi = true),
                            (ubiSelect = false)
                        "
                        class="asociar"
                      >
                        <div id="cardivA">
                          <p class="cardTit">Asociar ubicación existente</p>
                          <p class="cardDes">
                            Los datos de ubicación de la zona seleccionada se
                            asignan automáticamente
                          </p>
                        </div>
                      </b-card>
                    </b-col>

                    <b-col>
                      <b-card
                        @click="
                          (selectAsociar = false),
                            (noAsociarUbi = true),
                            (ubiSelect = false),
                            resetLocationValues()
                        "
                        id="manual"
                      >
                        <div id="cardivB">
                          <p class="cardTit">Introducir ubicación manual</p>
                          <p class="cardDes">
                            Asignar datos de ubicación manualmente
                          </p>
                        </div>
                      </b-card>
                    </b-col>
                  </b-row>
                  <p class="errorValidacion" v-if="ubiSelect">
                    Seleccione una opción antes de continuar
                  </p>
                </div>

                <!-- CONTENEDOR ASOCIAR UBICACIÓN (OCULTO POR DEFECTO)-->
                <div id="asociarUbi" v-if="asociarUbi">
                  <p>
                    Escoja la ubicación que desea asociar y haga click en
                    <span class="resaltarBien">Siguiente</span>
                  </p>
                  <b-form-select
                    size="xl"
                    select-size="6"
                    id="location_ref"
                    name="location_ref"
                    v-model="selectedLocation"
                    style="margin-bottom: 20px"
                  >
                    <b-form-select-option
                      v-bind="null"
                      value="null"
                      style="
                        color: #17a2b8;
                        font-weight: bold;
                        pointer-events: none;
                      "
                      >Seleccione una ubicación...
                    </b-form-select-option>

                    <b-form-select-option
                      v-for="(locationItem, index) in locationList"
                      v-bind:key="index"
                      v-bind:value="locationItem"
                    >
                      {{ locationItem }}
                    </b-form-select-option>
                  </b-form-select>
                  <p class="errorValidacion" v-if="ubiNonSelected">
                    Debe seleccionar una ubicación de la lista antes de
                    continuar
                  </p>
                </div>

                <!-- CONTENEDOR UBICACIÓN MANUAL (OCULTO POR DEFECTO)-->
                <div id="NoAsociarUbi" v-if="noAsociarUbi">
                  <p>Información de ubicación de su nuevo nodo</p>
                  <b-row>
                    <b-col>
                      <b-card title="" id="provincia">
                        <div class="cardContent">
                          <label for="provinciainput">Provincia</label>
                          <b-form-input
                            v-model="device.location.province"
                            v-bind:required="true"
                            style="width: 80%; margin: auto"
                            name="provinciainput"
                          />
                        </div>
                      </b-card>
                    </b-col>
                    <b-col>
                      <b-card title="" id="codPost">
                        <div class="cardContent">
                          <label for="codPostinput">Código postal</label>
                          <b-form-input
                            v-model="device.location.zip"
                            v-bind:required="true"
                            @keydown.native="zipCodeKeyDown($event)"
                            style="width: 80%; margin: auto"
                            name="codPostinput"
                          />
                        </div>
                      </b-card>
                    </b-col>
                  </b-row>
                  <b-row style="margin-bottom: 20px">
                    <b-col>
                      <b-card title="" id="latitud">
                        <div class="cardContent">
                          <label for="latitudinput">Latitud</label>
                          <b-form-input
                            v-model="device.location.latitude"
                            v-bind:required="true"
                            @keydown.native="coordinatesKeyDown($event)"
                            style="width: 80%; margin: auto"
                            name="latitudinput"
                          />
                        </div>
                      </b-card>
                    </b-col>
                    <b-col>
                      <b-card title="" id="longitud">
                        <div class="cardContent">
                          <label for="longitudinput">Longitud</label>
                          <b-form-input
                            v-model="device.location.longitude"
                            v-bind:required="true"
                            @keydown.native="coordinatesKeyDown($event)"
                            style="width: 80%; margin: auto"
                            name="longitudinput"
                          />
                        </div>
                      </b-card>
                    </b-col>
                  </b-row>
                  <p class="errorValidacion" v-if="ubiCamposVacios">
                    Debe rellenar los campos Provincia y Código postal
                  </p>
                </div>
              </b-col>
            </b-row>

            <b-row>
              <b-col>
                <!-- BOTON VOLVER A SELECCIÓN (OCULTO POR DEFECTO)-->
                <b-button
                  style="
                    position: absolute;
                    margin-left: -65px;
                    margin-top: 10px;
                    height: 35px;
                  "
                  variant="info"
                  size="sm"
                  v-if="!selectAsociar"
                  @click="
                    (selectAsociar = true),
                      (asociarUbi = false),
                      (noAsociarUbi = false),
                      (ubiNonSelected = false),
                      (ubiCamposVacios = false),
                      (selectedLocation = null)
                  "
                >
                  Volver a selección
                </b-button>
              </b-col>
            </b-row>
          </div>
        </tab-content>

        <!-- PESTAÑA 3: SENSORES-->
        <tab-content title="Asociar sensores" 
        :before-change="validateSensors"
        >
          <div class="contab">
            <b-row>
              <b-col>
                <!--CONTENEDOR OPCION DE ASOCIAR TIPO-->
                <div
                  id="selectType"
                  v-if="selectSpecType"
                  style="min-height: 400px"
                >
                  <p>¿Desea crear sensores predeterminados para este nodo?</p>
                  <p>
                    Pulse <span id="resaltarMal">Omitir</span> para saltar
                    este paso
                  </p>
                  <b-row>
                    <b-col>
                      <b-card
                        @click="(selectSpecType = false), (asociarType = true), (nextLabel = 'Siguiente')"
                        class="asociarType"
                      >
                        <div id="cardivC">
                          <p class="cardTit">
                            Asociar sensores predeterminados
                          </p>
                          <p class="cardDes" style="font-size: 110%">
                            Elija qué tipo de nodo desea crear y los sensores se
                            le asociarán de manera automática.
                          </p>
                        </div>
                      </b-card>
                    </b-col>
                  </b-row>
                </div>

                <!-- CONTENEDOR SELECCIONAR TIPO (OCULTO POR DEFECTO)-->
                <div
                  id="asoType"
                  v-if="asociarType"
                  @click="getSelectedTypeKey"
                >
                  <p>
                    Escoja el tipo de sensor que desea asociar y haga click en
                    <span class="resaltarBien">Siguiente</span>
                  </p>
                  <b-form-select
                    size="xl"
                    select-size="6"
                    id="type_ref"
                    name="type_ref"
                    v-model="selectedTypeAlias"
                    style="margin-bottom: 20px"
                  >
                    <b-form-select-option
                      v-bind="null"
                      value="null"
                      style="
                        color: #17a2b8;
                        font-weight: bold;
                        pointer-events: none;
                      "
                      >Seleccione un tipo de nodo...
                    </b-form-select-option>

                    <b-form-select-option
                      v-for="(typeItem, index) in typeList"
                      v-bind:key="index"
                      v-bind:value="typeItem.alias"
                    >
                      {{ typeItem.alias }}
                    </b-form-select-option>
                  </b-form-select>
                  <p class="errorValidacion" v-if="typeNonSelected">
                    Debe seleccionar un tipo de la lista antes de continuar
                  </p>
                  <div v-if="!typeNonSelected">
                    <p
                      style="
                        color: #17a2b8;
                        font-weight: bold;
                        text-align: left;
                        margin-left: 80px;
                      "
                    >
                      {{`${selectedTypeAlias? "El nodo " + selectedTypeAlias + " contiene: ": ""}`}}
                    </p>
                    <p
                      v-for="(line, index) in typeDescription"
                      v-bind:key="index"
                      v-bind:value="line"
                      style="color: black; text-align: left; margin-left: 100px"
                    >
                      {{ line }}
                    </p>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <!-- BOTON VOLVER A OPCION DE ASOCIAR TIPO (OCULTO POR DEFECTO)-->
                <b-button
                  style="
                    position: absolute;
                    margin-left: -45px;
                    margin-top: 10px;
                    height: 35px;
                  "
                  variant="info"
                  size="sm"
                  v-if="!selectSpecType"
                  @click="
                    (selectSpecType = true),
                      (asociarType = false),
                      (selectedTypeAlias = null),
                      (typeDescription = [
                        'Seleccione un tipo de nodo de la lista para mostrar su descripción',
                      ]),
                      (selectedTypeKey = null),
                      (typeNonSelected = false),
                      (nextLabel = 'Omitir')
                  "
                >
                  Volver
                </b-button>
              </b-col>
            </b-row>
          </div>
        </tab-content>

        <!-- PESTAÑA 4: RESUMEN-->
        <tab-content title="Resumen" :before-change="validateAsync">
          <div class="contab">
            <p>Resumen de su nuevo nodo</p>
            <b-row>
              <b-col class="resumen">
                <p>DATOS IDENTIFICACIÓN</p>
                <p>
                  Alias: <span id="res-alias">{{ device.alias }}</span>
                </p>
                <p>
                  UUID: <span id="res-uuid">{{ device.uuid }}</span>
                </p>
                <p>
                  Estado: 
                  <span style="color: green; font-size: 120%; font-weight: bold;">{{ device.status? "ACTIVO":"" }}</span>
                  <span style="color: red; font-size: 120%; font-weight: bold;">{{ !device.status? "INACTIVO":"" }}</span>
                </p>
              </b-col>
              <b-col class="resumen">
                <p>DATOS UBICACIÓN</p>
                <p>
                  Asociado a:
                  <span id="res-aso">{{
                    selectedLocation ? selectedLocation : "Ninguna localización"
                  }}</span>
                </p>
                <p>
                  Provincia:
                  <span id="res-prov">{{ device.location.province }}</span>
                </p>
                <p>
                  Código postal:
                  <span id="res-zip">{{ device.location.zip }}</span>
                </p>
                <p>
                  Latitud:
                  <span id="res-lat">{{
                    device.location.latitude
                      ? device.location.latitude
                      : "sin especificar"
                  }}</span>
                </p>
                <p>
                  Longitud:
                  <span id="res-long">{{
                    device.location.longitude
                      ? device.location.longitude
                      : "sin especificar"
                  }}</span>
                </p>
              </b-col>
              <b-col class="resumen">
                <p>DATOS SENSÓRICA</p>
                <p>
                  Tipo de nodo:
                  <span id="res-tipo">{{
                    selectedTypeAlias ? selectedTypeAlias : "Ningún tipo"
                  }}</span>
                </p>
                <div v-if="selectedTypeAlias">
                  <p
                    v-for="(line, index) in typeDescription"
                    v-bind:key="index"
                    v-bind:value="line"
                    id="anulaFirstChild"
                    style="font-size: 80%"
                  >
                    Sensor {{ index + 1 }}: <span>{{ line }}</span>
                  </p>
                </div>
              </b-col>
            </b-row>
            <div class="form-check form-switch" style="margin-top: 20px; font-weight: bold; color: #17a2b8; font-size: 150%;">
              <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault" v-model="device.status">
              <label class="form-check-label" for="flexSwitchCheckDefault">Activar nodo</label>
            </div>
          </div>
        </tab-content>
      </form-wizard>
    </div>
  </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import DeviceService from "@/services/DeviceService";
import LocationService from "@/services/LocationService";
import UserService from "@/services/UserService";

import CircleLoader from "@/components/common/CircleLoader";
//import Input from "@/components/common/form/Input";
//import Button from "@/components/common/form/Button";

export default {
  name: "Wizard",
  components: {
    "circle-loader": CircleLoader,
    "form-wizard": FormWizard,
    "tab-content": TabContent,
  },
  //Datos del componente
  data() {
    return {
      //Boolean para determinar si el wizard está en modo de espera
      loadingWizard: false,

      //Boolean para determinar si se han rellenado los campos de la pestaña identificación
      identCamposVacios: false,

      //Boolean para determinar si se ha introducido un alias de nodo duplicado
      identAliasDuplicado: false,

      //Boolean para determinar si se ha seleccionado una opción de ubicación
      ubiSelect: false,

      //Boolean para determinar si no se ha seleccionado ninguna ubicación
      ubiNonSelected: false,

      //Boolean para determinar si se han rellenado los campos provincia y zip en modo manual
      ubiCamposVacios: false,

      //Boolean para activar el contenedor de SELECCIÓN (ÚNICO BOOLEAN INICIALIZADO A TRUE DE UBICACIONES)
      selectAsociar: true,

      //Boolean para activar el contenedor ASOCIAR UBICACIÓN
      asociarUbi: false,

      //Boolean para activar el contenedor UBICAIÓN MANUAL
      noAsociarUbi: false,

      //Objeto para almacenar temporalmente los datos del nodo a crear
      device: {
        alias: null,
        uuid: null,
        location_ref: null,
        group: null,
        location: {
          province: null,
          zip: null,
          latitude: null,
          longitude: null,
          gpsForced: false,
        },
        status: null,
      },

      //Array de objetos Location que recibimos del backend
      objectLocationList: [],
      //Array de String de alias de las localizaciones
      locationList: [],
      //String de alias de la localización seleccionada por el usuario
      selectedLocation: null,

      //Array de objetos key alias de tipo de nodo
      typeList: null,
      //String de alias de tipo de nodo seleccionado
      selectedTypeAlias: null,
      //String de key de tipo de nodo seleccionado
      selectedTypeKey: null,
      //Objeto con la informacion de los tipos de nodo
      specTypeObject: null,

      //Descripción del tipo de nodo
      typeDescription: [
        "Seleccione un tipo de nodo de la lista para mostrar su descripción",
      ],

      //Boolean para activar el contenedor de opción de asociar tipo de nodo (ÚNICO BOOLEAN INICIALIZADO A TRUE DE TIPOS DE NODO)
      selectSpecType: true,
      //Boolean para activar el contenedor de selcción de tipo de nodo
      asociarType: false,
      //Boolean para determinar si no se ha selecionado ningún tipo de nodo
      typeNonSelected: false,

      //Objeto para guardar temporalmente el tipo de nodo predeterminado
      presetNodeType: {
        alias: null,
        sensors: {},
      },
      //Boolean para olcultar el Wizard
      submitted: false,

      nextLabel: "Siguiente",
    };
  },
  mounted() {
    //Cargamos la información necesaria
    this.retrieveLocation();
    this.retrieveType();
    this.resetValues();
  },
  methods: {
    //Métodos del componente

    //Este metodo se ejecuta al pulsar el botón "Crear nodo"
    onComplete() {
      //this.createDevice();
      //alert("Nodo guardado correctamente");
      //window.location.reload();
      console.log("ONCOMPLETE");
    },

    //este método se ejecuta cuando el wizard esté en estado de espera
    setLoading(value) {
      this.loadingWizard = value;
    },

    //Este método se ejecuta al pulsar el botón "Siguiente" de cada pestaña, idica por consola si la pestaña es válida
    handleValidation: function (isValid, tabIndex) {
      console.log("Tab: " + tabIndex + " valid: " + isValid);
    },

    //Método por defecto para validar una pestaña del formulario, es el encarcado de establecer
    //un timeout durante el cual el cual el wizard permanece en estado de espera
    validateAsync() {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(true);
        }, 500);
      });
    },

    //Método para validar la pestaña 1: IDENTIFICACIÓN
    validateIdentity() {
      return new Promise((resolve, reject) => {
        setTimeout(async () => {
          if (this.device.alias && this.device.uuid) {
            let enviar = true;
            this.identCamposVacios = false;
            let buscaDevices = await DeviceService.getAll();
            buscaDevices.data.forEach((element) => {
              if (element.alias == this.device.alias) {
                this.identAliasDuplicado = true;
                console.log("ALIAS DUPLICADO");
                enviar = false;
              }
            });
            this.identAliasDuplicado = enviar ? false : true;
            resolve(enviar);
          } else {
            this.identCamposVacios = true;
            resolve(false);
          }
        }, 500);
      });
    },

    //Método para validar la pestaña 2: UBICACIÓN
    validateLocation() {
      return new Promise((resolve, reject) => {
        setTimeout(async () => {
          if (this.selectAsociar) {
            this.ubiSelect = true;
            resolve(false);
          } else if (this.asociarUbi) {
            this.ubiSelect = false;
            if (!this.selectedLocation) {
              this.ubiNonSelected = true;
              resolve(false);
            } else {
              this.ubiNonSelected = false;
              // A partir del alias de la localización obtenemos los valores para la ubicación del nodo
              let responseLocation = await LocationService.findByAlias(
                this.selectedLocation
              );
              console.log("----DATOS DE LOCALIZACION----");
              console.log(responseLocation.data);
              //this.device.location_ref = responseLocation.data;
              this.device.location.zip = responseLocation.data.location.zip;
              this.device.location.province =
                responseLocation.data.location.province;
              this.device.location.latitude =
                responseLocation.data.location.latitude;
              this.device.location.longitude =
                responseLocation.data.location.longitude;
              this.nextLabel="Omitir"
              resolve(true);
            }
          } else {
            this.ubiSelect = false;
            if (!this.device.location.province || !this.device.location.zip) {
              this.ubiCamposVacios = true;
              resolve(false);
            } else {
              this.ubiCamposVacios = false;
              this.nextLabel="Omitir"
              resolve(true);
            }
          }
        }, 500);
      });
    },

    //Método para validar la pestaña 3: ASOCIAR SENSORES
    validateSensors() {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          if (this.selectSpecType) {
            this.typeNonSelected = false;
            this.nextLabel="Siguiente"
            resolve(true);
          } else if (this.selectedTypeKey) {
            this.typeNonSelected = false;
            this.nextLabel="Siguiente"
            resolve(true);
          } else {
            this.typeNonSelected = true;
            this.nextLabel="Siguiente"
            resolve(false);
          }
        }, 500);
      });
    },

    //Resetea los valores de la localización para que siempre aparezca el formulario
    //de introducción manual vacío.
    resetLocationValues() {
      this.device.location_ref = null;
      this.device.location.province = null;
      this.device.location.zip = null;
      this.device.location.latitude = null;
      this.device.location.longitude = null;
    },

    //Método encargado de validar las teclas de entrada para el código postal
    //Este método sólo acepta teclas numericas y teclas para borrar y mover el cursor
    zipCodeKeyDown(event) {
      if (
        event.key != "Backspace" &&
        event.key != "Delete" &&
        event.key != "ArrowLeft" &&
        event.key != "ArrowRight" &&
        isNaN(Number(event.key))
      ) {
        event.preventDefault();
      }
    },

    //Método encanragado de validar las teclas de entrada para las
    //coordenadas geográficas. A parte de las teclas que permite zipCodeKeyDown
    //este también permite las teclas para poner decimales y negativos
    coordinatesKeyDown(event) {
      if (
        event.key != "Backspace" &&
        event.key != "Delete" &&
        event.key != "ArrowLeft" &&
        event.key != "ArrowRight" &&
        event.key != "," &&
        event.key != "." &&
        event.key != "-" &&
        isNaN(Number(event.key))
      ) {
        event.preventDefault();
      }
    },

    //Método para rellenar la lista de localizaciones
    async retrieveLocation() {
      await LocationService.getAll()
        .then((response) => {
          this.objectLocationList = response.data;
          for (var i = 0; i < this.objectLocationList.length; i++) {
            var obj = this.objectLocationList[i];
            this.locationList.push(obj.alias);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    //Método para llenar la lista de key + alias de tipo de nodo y el objeto specTypeObject
    async retrieveType() {
      await DeviceService.getSpecTypeKeyAlias()
        .then((response) => {
          this.typeList = response.data;
        })
        .catch((e) => {
          console.log(e);
        });
      await DeviceService.getSpecType()
        .then((response) => {
          this.specTypeObject = response.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },

    //Método para comprobar si el usuario es administrador
    isUserAdmin() {
      return UserService.isUserAdmin();
    },

    //Método para resetear los datos del componente
    resetValues() {
      // Reset our form values
      this.device.alias = null;
      this.device.group = null;
      this.device.location_ref = null;
      this.selectedLocation = null;
      this.device.uuid = null;
      this.device.status = false;
      this.device.location.zip = null;
      this.device.location.province = null;
      this.device.location.latitude = null;
      this.device.location.longitude = null;
      this.device.location.gpsForced = null;
    },

    saveDevice() {
      if (this.device.location.latitude) {
        this.device.location.latitude = Number(
          this.device.location.latitude.replace(",", ".")
        );
      }
      if (this.device.location.longitude) {
        this.device.location.longitude = Number(
          this.device.location.longitude.replace(",", ".")
        );
      }
      this.fillLocationData(this.createDevice());
    },

    fillLocationData(callback) {
      if (this.selectedLocation) {
        let selectedLocationObject = this.objectLocationList.filter((item) => {
          return item.alias == this.selectedLocation;
        });
        this.device.location_ref = selectedLocationObject[0];
        callback();
      } else {
        this.device.location_ref = null;
        callback();
      }
    },

    //Método para crear un nodo con los valores introducidos por el usuario
    async createDevice() {
      try {
        this.$refs.circleLoader.reset();
        this.$refs.circleLoader.showLoading("Registrando nodo ...");

        let data = {
          group: this.device.group,
          location_ref: this.selectedLocation,
          uuid: this.device.uuid,
          alias: this.device.alias,
          //type: "-",
          status: this.device.status ? true : false,
          specTypeKey: this.selectedTypeKey,
          location: {
            zip: this.device.location.zip,
            province: this.device.location.province,
            latitude: this.device.location.latitude,
            longitude: this.device.location.longitude,
            gpsForced: this.device.location.gpsForced,
          },
        };

        // fillLocationData
        if (this.selectedLocation) {
          let responseLocation = await LocationService.findByAlias(
            this.selectedLocation
          );
          data.location_ref = responseLocation.data;
        }
        let response = await DeviceService.create(data);
        //Mensaje de confirmacion
        this.$notify({
          group: "notificateDiv",
          type: "success",
          title: response.data.message
            ? response.data.message
            : "Nodo agregado correctamente",
          text: response.data.message
            ? ""
            : "Se ha agregado 1 nuevo nodo a la lista",
          duration: 3000,
          speed: 1000,
        });
        //Completar imagen y descargar div
        //Ocultamos el formulario
        this.submitted = true;
        //Mostramos durante 2 segundos que se está gaurdando
        setTimeout(() => {
          //Comprobar cabeceras e vuelta para cargar la X o el tick
          if (!response.data.message) {
            this.$refs.circleLoader.showEndError(
              "No se ha podido registrar el nodo"
            );
          } else {
            this.$refs.circleLoader.showEndSuccess(
              "Nodo almacenado correctamente"
            );
          }
          //Temporizador antes de mostrar de nuevo el formulario
          setTimeout(() => {
            //Emitimos para notificar al otro componente
            this.$emit("onClickSave");
            //Reseteamos los valores
            this.resetValues();
            //Recargamos la ventana
            window.location.reload();
          }, 1500);
        }, 2500);
      } catch (error) {
        let errorMessage = error;

        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message
        ) {
          errorMessage = error.response.data.message;
        }

        this.$notify({
          group: "notificateDiv",
          type: "error",
          title: "Error al guardar el nodo",
          text: errorMessage,
          duration: 3000,
          speed: 1000,
        });

        console.log(error);
        throw new Error("Error - NodesEditForm.vue - createDevice");
      }
    },

    //Este método se llama cada vez que el usuario hace click en alguna parte del
    //contenedor de seleccion de tipo de nodo, pero solo actúa si hay un tipo
    //de nodo seleccionado
    getSelectedTypeKey() {
      if (this.selectedTypeAlias) {
        this.typeNonSelected = false;
        this.typeList.forEach((type) => {
          if (this.selectedTypeAlias == type.alias) {
            this.selectedTypeKey = type.key;
            this.typeDescription = this.specTypeObject[type.key].description;
            return;
          }
        });
      }
    },
    // ^ Insertar método en la linea de arriba (no olvidar la coma) ^
  },
};
</script>
<style scoped>
.loader,
.loader:after {
  border-radius: 50%;
  width: 10em;
  height: 10em;
}
.loader {
  margin: -11.5em 0em 0em 48.5em;
  font-size: 10px;
  position: absolute;
  text-indent: -9999em;
  border-top: 1.1em solid rgba(255, 255, 255, 0.2);
  border-right: 1.1em solid rgba(255, 255, 255, 0.2);
  border-bottom: 1.1em solid rgba(255, 255, 255, 0.2);
  border-left: 1.1em solid #5e7ad8;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation: load8 0.5s infinite linear;
  animation: load8 0.5s infinite linear;
}
@-webkit-keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes load8 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.contab {
  text-align: center;
  width: 80%;
  margin: auto;
  position: relative;
}

.cardContent {
  position: relative;
  font-size: 20px;
  color: blue;
  font-weight: bold;
}

#alias {
  /*background-image: url("../../assets/images/alias.png");*/
  background-repeat: no-repeat;
  background-size: 200px 60px;
  background-position: top;
}
#alias:hover {
  background-color: skyblue;
}
#alias:before {
  content: "";
  width: 100%;
  height: 100%;
  background-color: white;
  opacity: 0.7;
  position: absolute;
}
#uuid {
  /*background-image: url("../../assets/images/uuid.png");*/
  background-repeat: no-repeat;
  background-size: 200px 60px;
  background-position: top;
}
#uuid:hover {
  background-color: skyblue;
}
#uuid:before {
  content: "";
  width: 100%;
  height: 100%;
  background-color: white;
  opacity: 0.7;
  position: absolute;
}

#select {
  margin-bottom: 20px;
}
#selectType {
  margin-bottom: 20px;
}

.asociar {
  width: 350px;
  height: 300px;
  background-image: url("../../assets/images/asigUbi.png");
  background-repeat: no-repeat;
  background-size: 300px 250px;
  background-position: center;
}
.asociar:hover {
  background-color: skyblue;
  cursor: pointer;
  border: solid;
  border-color: skyblue;
}
.asociar:before {
  content: "";
  width: 100%;
  height: 100%;
  background-color: white;
  opacity: 0.8;
  position: absolute;
}

.asociarType {
  width: 350px;
  height: 300px;
  background-image: url("../../assets/images/asigUbi.png");
  background-repeat: no-repeat;
  background-size: 300px 250px;
  background-position: center;
  position: absolute;
  margin-left: 250px;
}
.asociarType:hover {
  background-color: skyblue;
  cursor: pointer;
  border: solid;
  border-color: skyblue;
}
.asociarType:before {
  content: "";
  width: 100%;
  height: 100%;
  background-color: white;
  opacity: 0.8;
  position: absolute;
}

#manual {
  width: 350px;
  height: 300px;
  background-image: url("../../assets/images/manualUbi.png");
  background-repeat: no-repeat;
  background-size: 300px 250px;
  background-position: center;
}
#manual:hover {
  background-color: skyblue;
  cursor: pointer;
  border: solid;
  border-color: skyblue;
}
#manual:before {
  content: "";
  width: 100%;
  height: 100%;
  background-color: white;
  opacity: 0.8;
  position: absolute;
}
.cardTit {
  font-weight: bold;
  font-size: 30px;
  color: blue;
}
.cardDes {
  font-size: 20px;
  color: black;
}

#cardivA {
  position: relative;
  padding-top: 30px;
}
#cardivB {
  position: relative;
  padding-top: 30px;
}
#cardivC {
  position: relative;
  padding-top: 30px;
}

#asociarUbi {
  width: 70%;
  margin: auto;
}
#location_ref {
  cursor: pointer;
}

#provincia {
  /*background-image: url("../../assets/images/provincia.png");*/
  background-repeat: no-repeat;
  background-size: 200px 60px;
  background-position: top;
}
#provincia:hover {
  background-color: skyblue;
}
#provincia:before {
  content: "";
  width: 100%;
  height: 100%;
  background-color: white;
  opacity: 0.7;
  position: absolute;
}
#codPost {
  /*background-image: url("../../assets/images/codPostal.png");*/
  background-repeat: no-repeat;
  background-size: 200px 60px;
  background-position: top;
}
#codPost:hover {
  background-color: skyblue;
}
#codPost:before {
  content: "";
  width: 100%;
  height: 100%;
  background-color: white;
  opacity: 0.7;
  position: absolute;
}
#latitud {
  /*background-image: url("../../assets/images/latitud.png");*/
  background-repeat: no-repeat;
  background-size: 200px 60px;
  background-position: top;
}
#latitud:hover {
  background-color: skyblue;
}
#latitud:before {
  content: "";
  width: 100%;
  height: 100%;
  background-color: white;
  opacity: 0.7;
  position: absolute;
}
#longitud {
  /*background-image: url("../../assets/images/longitud.png");*/
  background-repeat: no-repeat;
  background-size: 200px 60px;
  background-position: top;
}
#longitud:hover {
  background-color: skyblue;
}
#longitud:before {
  content: "";
  width: 100%;
  height: 100%;
  background-color: white;
  opacity: 0.7;
  position: absolute;
}
.errorValidacion {
  color: red;
}
.resumen {
  border-style: solid;
  border-color: #17a2b8;
  border-radius: 10px;
  background: white;
  margin-right: 10px;
}
.resumen:last-child {
  margin-right: none;
}
.resumen p {
  text-align: left;
  color: #17a2b8;
}

.resumen p span {
  color: rgb(104, 104, 255);
  font-weight: bold;
  margin-left: 10px;
}

.resumen p:first-child {
  text-align: center;
  color: white;
  font-size: 120%;
  font-weight: bold;
  background: #17a2b8;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
}
.resumen #anulaFirstChild {
  text-align: left;
  color: #17a2b8;
  font-size: 100%;
  font-weight: normal;
  background: white;
  border-bottom-left-radius: none;
  border-bottom-right-radius: none;
}
#resaltarMal {
  font-size: 110%;
  color: red;
  font-weight: bold;
}
.resaltarBien {
  font-size: 110%;
  color: green;
  font-weight: bold;
}
</style>